import { ChevronDown } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FIRST_MESSAGE_MODE_OPTIONS } from "../../utils/assistants/base";
import { appendToAssistantDetail } from "../../store/app/assistantSlice";

function AgentComponent() {
  const dispatch = useDispatch();

  // Grab assistant details from Redux
  const assistantDetails = useSelector((state) => state.assistants.activeDetail.details);

  const firstMessage = assistantDetails?.firstMessage || "";
  const promptMessage = assistantDetails?.model?.messages?.[0]?.content || "";

  const messageMode = assistantDetails?.firstMessageMode;

  // Local state
  const [firstMessageMode, setFirstMessageMode] = useState("");
  const [updatedMessage, setUpdatedMessage] = useState("");
  const [updatedPrompt, setUpdatedPrompt] = useState("");

  // Initialize local states when assistant details change
  useEffect(() => {
    setUpdatedMessage(firstMessage);
    setUpdatedPrompt(promptMessage);
    setFirstMessageMode(messageMode ?? ""); 
  }, [firstMessage, promptMessage, messageMode]);

  // Sync local changes to Redux
  useEffect(() => {
    // Compose updated payload
    const formattedData = {
      ...(firstMessageMode && { firstMessageMode }), 
      firstMessage: updatedMessage,
      model: {
        provider: assistantDetails?.model?.provider,
        model: assistantDetails?.model?.model,
        messages: [
          {
            role: "system",
            content: updatedPrompt,
          },
        ],
      },
    };

    dispatch(appendToAssistantDetail(formattedData));
  }, [firstMessageMode, updatedMessage, updatedPrompt, dispatch, assistantDetails]);

  return (
    <div className="card p-20 m-10">
      {/* === First Message Mode Dropdown === */}
      <label htmlFor="first-message-mode" className="agent-form-label">
        First Message Mode
      </label>
      <div style={{ position: "relative", flex: 1 }}>
        <select
          id="first-message-mode"
          value={firstMessageMode}
          onChange={(e) => setFirstMessageMode(e.target.value)}
          className="agent-form-input flex-1"
          style={{ paddingRight: "2.5rem", appearance: "none" }}
        >
          <option value="" disabled style={{ color: "grey" }}>
            Select First Message mode
          </option>
          {FIRST_MESSAGE_MODE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown
          size={20}
          style={{
            position: "absolute",
            right: "12px",
            top: "40%",
            transform: "translateY(-50%)",
            color: "#9CA3AF",
            pointerEvents: "none",
          }}
        />
      </div>

      {/* === Assistant Welcome Message === */}
      <label htmlFor="welcome-message" className="agent-form-label mt-4">
        Assistant Welcome Message
      </label>
      <input
        id="welcome-message"
        type="text"
        className="agent-form-input"
        value={updatedMessage}
        onChange={(e) => setUpdatedMessage(e.target.value)}
      />
      <p className="agent-form-note">
        This will be the initial message from the agent. Variables like <code>{'{{variable_name}}'}</code> are supported.
      </p>

      {/* === Agent Prompt (System Message) === */}
      <label htmlFor="agent-prompt" className="agent-form-label mt-4">
        Agent Prompt
      </label>
      <textarea
        id="agent-prompt"
        className="agent-form-textarea"
        style={{ height: "350px" }}
        value={updatedPrompt}
        onChange={(e) => setUpdatedPrompt(e.target.value)}
      />
      <p className="agent-form-note">
        You can define variables in the prompt using <code>{'{variable_name}'}</code>.
      </p>
    </div>
  );
}

export default AgentComponent;
